module.exports = __webpack_public_path__ + "img/latvia.b07e3abd.svg";